module.exports = "/images/button-plus-icon.svg?3079ad8198dfbed722eb79a1429faa84";